import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import { campaignTypes } from 'constants/campaigns';
import fetch from 'features/common/fetch';
import campaignManagers from 'features/views/campaignDashboards/campaignManagers';

import ManagersTableRow from './ManagersTableRow';

export const ManagersTable = ({ campaignType }) => {
	const dispatch = useDispatch();

	const managers = useSelector(campaignManagers.selectors.getManagers);
	const hasRecords = !isEmpty(managers);

	const handleReload = useCallback(() => {
		dispatch(campaignManagers.actions.reload());
	}, [dispatch]);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.dashboardManagersOfRegion} onReload={handleReload}>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('dashboardRegion:subheader')} />
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell>{getLabelMessage('dashboardRegion:manager')}</TableCell>
									<TableCell>{getLabelMessage('dashboardCentral:progress')}</TableCell>
									<TableCell>{getLabelMessage('dashboardCentral:notDone')}</TableCell>
									<TableCell>{getLabelMessage('dashboardCentral:addMatFulfillment')}</TableCell>
									{campaignType === campaignTypes.UP_SELL && (
										<TableCell>{getLabelMessage('dashboardCentral:replication')}</TableCell>
									)}
									<TableCell>{getLabelMessage('dashboardCentral:production')}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{!hasRecords ? (
									<TableHasNoResults />
								) : (
									managers.map((manager, index) => (
										<TableRow key={index}>
											<ManagersTableRow manager={manager} campaignType={campaignType} />
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</Stack>
			</Paper>
		</ComponentLoader>
	);
};

ManagersTable.propTypes = {
	campaignType: PropTypes.number,
};

export default ManagersTable;
